import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';
import { Certification } from '@modules/organisation-workspaces/models/certification-matrix';

@Injectable({
  providedIn: 'root'
})
export class CertificationsApiService extends ApiService {
  readonly resourcePath = 'default_certifications';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<Certification>> {
    return this.restList<Certification>(filters);
  }

  get(id: string): Observable<Certification> {
    return this.restRead<Certification>(id);
  }

  create(data: object): Observable<Certification> {
    return this.restCreate<Certification>(data);
  }

  update(id: string, data: object): Observable<Certification> {
    return this.restUpdate<Certification>(id, data);
  }

  delete(id: string): Observable<any> {
    return this.restDelete(id);
  }
}
